<template>
	<div>
		<b-row class="mt-2">
			<b-col md="6">
				<FormGroup :state="valid">
					<b-input
						v-model="password"
						type="password"
						:placeholder="placeholder1"
						@focusin="showRequirements = true"
						@focusout="showRequirements = false"
						@input="emitChangeEvent"
					/>
				</FormGroup>
			</b-col>
			<b-col md="6">
				<FormGroup :state="valid" class="mt-2 mt-md-0">
					<b-input
						v-model="password2"
						type="password"
						:placeholder="placeholder2"
						@focusin="showRequirements = true"
						@focusout="showRequirements = false"
						@input="emitChangeEvent"
					/>
				</FormGroup>
			</b-col>
		</b-row>
		<FormGroup v-if="showRequirements || bothFilled">
			<Requirements
				prefix="Mindestens:"
				:requirements="requirements"
			/>
		</FormGroup>
	</div>
</template>

<script>
import {isEmptyOrNull} from "@/helper/String";
import _ from "lodash";
import FormGroup from "@/vue/common/form/Group";
import Requirements from "@/vue/common/form/group/Requirements";

const MIN_LENGTH = 8;

export default {

	components: {
		Requirements,
		FormGroup,
	},

	props: {
		value: {
			type: String,
			required: false,
		},
		placeholder1: {
			type: String,
			required: false,
			default: 'Passwort',
		},
		placeholder2: {
			type: String,
			required: false,
			default: 'Passwort (wiederholen)',
		},
	},

	data ()
	{
		return {
			password: '',
			password2: '',
			showRequirements: false
		};
	},

	computed: {
		requirements ()
		{
			return [
				{
					key: 'length',
					label: '8 Stellen',
					valid: this.lengthValid,
				},
				{
					key: 'uppercase',
					label: '1 Großbuchstabe',
					valid: this.uppercaseLetterValid,
				},
				{
					key: 'lowercase',
					label: '1 Kleinbuchstabe',
					valid: this.lowercaseLetterValid,
				},
				{
					key: 'figure',
					label: '1 Ziffer',
					valid: this.figureValid,
				},
				{
					key: 'repeat',
					label: 'Bestätigung',
					valid: this.repeatValid,
				},
			];
		},
		bothFilled ()
		{
			return !isEmptyOrNull(this.password)
				&& !isEmptyOrNull(this.password2);
		},
		lengthValid ()
		{
			return !isEmptyOrNull(this.password) && _.trim(this.password).length >= MIN_LENGTH;
		},
		uppercaseLetterValid ()
		{
			return !isEmptyOrNull(this.password) && this.password.match(/[A-ZÖÄÜ]+/g);
		},
		lowercaseLetterValid ()
		{
			return !isEmptyOrNull(this.password) && this.password.match(/[a-zäöü]+/g);
		},
		figureValid ()
		{
			return !isEmptyOrNull(this.password) && this.password.match(/[0-9]+/g);
		},
		repeatValid ()
		{
			return !isEmptyOrNull(this.password2) && this.password === this.password2;
		},
		valid ()
		{
			return this.requirements.length === _.filter(this.requirements, r => r.valid).length;
		}
	},

	methods: {
		reset ()
		{
			this.password = '';
			this.password2 = '';
		},
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', this.password);
		}
	},
}
</script>
